// extracted by mini-css-extract-plugin
module.exports = {"table":"ivf-egg-rank-detail-table_table__3_GqO","total":"ivf-egg-rank-detail-table_total__1wjgl"};